import {
  Drawer,
  DrawerClose,
  DrawerContent as DrawerContentBase,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerPortal,
  DrawerTitle,
  DrawerTrigger,
} from '@/components/ui/drawer'
import { cn } from '@/lib/utils'

/**
 * Bottom sheets cap at 85dvh (dvh, so the iOS toolbar never pushes the footer
 * off-screen) and clear the home indicator.
 */
function DrawerContent({
  className,
  ...props
}: React.ComponentProps<typeof DrawerContentBase>) {
  return (
    <DrawerContentBase
      className={cn(
        'data-[vaul-drawer-direction=bottom]:max-h-[85dvh] data-[vaul-drawer-direction=bottom]:pb-[calc(0.5rem+env(safe-area-inset-bottom,0px))]',
        className,
      )}
      {...props}
    />
  )
}

export {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerPortal,
  DrawerTitle,
  DrawerTrigger,
}
